export default "__VITE_ASSET__$tsGOIfA__"